import { render, staticRenderFns } from "./aml.vue?vue&type=template&id=5ca31f6f&"
import script from "./aml.vue?vue&type=script&lang=js&"
export * from "./aml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports